import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { useTranslation } from 'react-i18next';

import { BaseText, Icon, RichText, Separator } from '@components';
import { IS_WEB } from '@utils';
import { Course } from '@models/Courses/CourseModel';

const Container = styled(View)({
  bg: '$background0',
  borderWidth: 1,
  borderColor: '$background30',
  borderRadius: 12,
  padding: ['$6', '$8'],
});

const Title = styled(BaseText)({
  variant: IS_WEB ? 'text.xxlarge' : 'text.large',
  color: '$heading800',
  fontWeight: 'semi',
});

const HighlightsContainer = styled(View)({
  flexDirection: ['column', 'row'],
  flexWrap: ['nowrap', 'wrap'],
});

const HighlightContainer = styled(View)({
  width: ['100%', '50%'],
  paddingRight: [0, '$4'],
});

const HighlightItem = styled(View)({
  flexDirection: 'row',
  alignItems: 'flex-start',
});

const HighlightText = styled(RichText)({
  variant: 'text.small',
  flex: 1,
  marginLeft: '$4',
});

interface ICourseHighlightsProps {
  course: Course;
}

export const CourseHighlights = ({
  course,
}: ICourseHighlightsProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{t('courseSummary.highlightsTitle')}</Title>
      <Separator size="$6" />
      <HighlightsContainer>
        {course.benefits.map((highlight, index) => {
          const isLast = index === course.benefits.length - 1;

          return (
            <HighlightContainer key={index}>
              <HighlightItem>
                <Icon
                  name="done-light"
                  color="$primary400"
                  size={16}
                />
                <HighlightText>{highlight}</HighlightText>
              </HighlightItem>
              {!isLast && <Separator size={['$5', '$6']} />}
            </HighlightContainer>
          );
        })}
      </HighlightsContainer>
    </Container>
  );
};
